import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";
import { CONTACT, LOGO_URL } from "../i18n/translations";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#121212] text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <img src={LOGO_URL} alt="Bola8 AzorHomes" className="h-16 w-auto brightness-0 invert mb-6" />
          <p className="text-white/60 text-sm max-w-sm leading-relaxed">
            {t.footer.tagline}
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="uppercase tracking-[0.2em] text-xs text-white/40 mb-5">
            {t.footer.company}
          </p>
          <ul className="space-y-3 text-sm">
            <li>
              <Link className="hover:text-white/60 transition" to="/sociedade" data-testid="footer-sociedade">
                {t.nav.sociedade}
              </Link>
            </li>
            <li>
              <Link className="hover:text-white/60 transition" to="/projetos" data-testid="footer-projetos">
                {t.nav.projetos}
              </Link>
            </li>
            <li>
              <Link className="hover:text-white/60 transition" to="/primewash" data-testid="footer-primewash">
                {t.nav.primewash}
              </Link>
            </li>
            <li>
              <Link className="hover:text-white/60 transition" to="/contactos" data-testid="footer-contactos">
                {t.nav.contactos}
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="uppercase tracking-[0.2em] text-xs text-white/40 mb-5">
            {t.footer.contact}
          </p>
          <ul className="space-y-4 text-sm text-white/80">
            <li className="flex gap-3">
              <MapPin className="w-4 h-4 mt-0.5 text-white/50 shrink-0" />
              <span>{CONTACT.address}</span>
            </li>
            <li className="flex gap-3 items-center">
              <Mail className="w-4 h-4 text-white/50 shrink-0" />
              <a href={`mailto:${CONTACT.email}`} className="hover:text-white transition" data-testid="footer-email">
                {CONTACT.email}
              </a>
            </li>
            <li className="flex gap-3 items-center">
              <Phone className="w-4 h-4 text-white/50 shrink-0" />
              <a href={`tel:${CONTACT.phoneRaw}`} className="hover:text-white transition" data-testid="footer-phone">
                {CONTACT.phone}
              </a>
            </li>
            <li className="flex gap-3 items-center">
              <ArrowUpRight className="w-4 h-4 text-white/50 shrink-0" />
              <a href={`https://${CONTACT.website}`} target="_blank" rel="noreferrer" className="hover:text-white transition">
                {CONTACT.website}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <p>© {year} Bola8 AzorHomes. {t.footer.rights}</p>
          <p className="uppercase tracking-[0.2em]">Açores — Portugal</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
